module.exports = __webpack_public_path__ + "img/video_loading.ccaf99a7.png";